import type { VideoItem } from "@/types";

export const videoList: VideoItem[] = [
  {
    id: "m1",
    title: "星际方舟",
    type: "movie",
    genres: ["科幻", "冒险"],
    region: "中国大陆",
    year: 2025,
    director: "林向阳",
    cast: ["陆沉", "苏晚", "周牧云", "何清"],
    rating: 8.9,
    hot: 9860,
    duration: "142分钟",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%20of%20a%20massive%20ark%20spaceship%20drifting%20toward%20a%20glowing%20blue%20nebula%2C%20dramatic%20rim%20light%2C%20dark%20space%20background%2C%20epic%20blockbuster%20key%20art%2C%20highly%20detailed&width=600&height=900&seq=ccvideo-m1&orientation=portrait",
    summary: "人类最后的方舟驶向未知星系，一场关于希望与牺牲的宇宙远征。",
    synopsis: [
      "当地球资源枯竭，人类建造了承载千万生命的巨型方舟「星辰号」，向着遥远星系中一颗可能宜居的行星出发。",
      "漫长的航程中，船员们逐渐发现航线数据被篡改，方舟真正驶向的目的地远比想象中凶险。舰长陆沉必须在真相与全船人的命运之间做出抉择。",
      "影片以宏大的宇宙图景与细腻的人性刻画，探讨漂泊与家园的永恒命题。",
    ],
    tags: ["宇宙", "远征", "硬科幻", "人类命运"],
  },
  {
    id: "m2",
    title: "暗夜追凶",
    type: "movie",
    genres: ["犯罪", "悬疑"],
    region: "中国大陆",
    year: 2024,
    director: "赵铭",
    cast: ["陈锋", "许安琪", "高岩"],
    rating: 8.4,
    hot: 9210,
    duration: "128分钟",
    cover:
      "https://readdy.ai/api/search-image?query=Crime%20thriller%20movie%20poster%20with%20a%20lone%20detective%20silhouette%20on%20a%20rainy%20neon%20city%20street%20at%20night%2C%20moody%20blue%20and%20orange%20lighting%2C%20shadowy%20atmosphere%2C%20suspenseful%20cinematic%20key%20art&width=600&height=900&seq=ccvideo-m2&orientation=portrait",
    summary: "一桩沉寂多年的悬案重启，刑警重走每一处被遗忘的现场。",
    synopsis: [
      "十年前的一起失踪案随着一段匿名视频重新浮出水面，老刑警陈锋被重新召回专案组。",
      "随着调查深入，案件牵出小城多年未被触碰的关系网络。真相藏在每一个被刻意忽略的细节里。",
      "影片节奏紧凑，氛围压抑而克制，是近年国产犯罪题材的诚意之作。",
    ],
    tags: ["犯罪", "悬疑", "追凶", "反转"],
  },
  {
    id: "m3",
    title: "春风十里遇你",
    type: "movie",
    genres: ["爱情", "剧情"],
    region: "中国大陆",
    year: 2025,
    director: "苏杭",
    cast: ["许安琪", "顾一野", "林夕"],
    rating: 7.9,
    hot: 7640,
    duration: "116分钟",
    cover:
      "https://readdy.ai/api/search-image?query=Romantic%20drama%20movie%20poster%20with%20a%20young%20couple%20walking%20through%20a%20sunlit%20spring%20field%20of%20flowers%2C%20soft%20warm%20golden%20hour%20light%2C%20dreamy%20bokeh%2C%20tender%20emotional%20cinematic%20art&width=600&height=900&seq=ccvideo-m3&orientation=portrait",
    summary: "一段从春天开始的相遇，考验着两颗心能否跨越时间与距离。",
    synopsis: [
      "在小城教书的设计师苏禾与返乡创业的顾言在春天相遇，两人从误会到相知，度过了一段被花香包裹的时光。",
      "当现实的压力与各自的梦想产生冲突，他们必须重新思考爱情与成长之间的距离。",
      "影片画面明快温暖，对白真诚，讲述了一个关于勇气与等待的爱情故事。",
    ],
    tags: ["爱情", "治愈", "青春", "成长"],
  },
  {
    id: "m4",
    title: "大唐风云录",
    type: "movie",
    genres: ["历史", "剧情"],
    region: "中国大陆",
    year: 2023,
    director: "王砚秋",
    cast: ["周牧云", "白鹭", "沈墨"],
    rating: 8.7,
    hot: 8130,
    duration: "156分钟",
    cover:
      "https://readdy.ai/api/search-image?query=Epic%20historical%20Chinese%20period%20movie%20poster%20of%20a%20bearded%20general%20in%20dynasty%20armor%20standing%20before%20ancient%20palace%20walls%2C%20amber%20and%20deep%20indigo%20color%20tone%2C%20majestic%20cinematic%20key%20art&width=600&height=900&seq=ccvideo-m4&orientation=portrait",
    summary: "王朝兴衰之际，一位将军用一生守护他心中的道义与家国。",
    synopsis: [
      "故事发生在王朝更迭的动荡年代，边关名将李承昭奉命镇守要塞，却卷入朝堂之上的暗流。",
      "在家国大义与个人恩怨之间，他以沉默的方式书写了一段不为人知的传奇。",
      "影片服化道考究，场面恢弘，对历史的想象克制而厚重。",
    ],
    tags: ["历史", "史诗", "权谋", "家国"],
  },
  {
    id: "m5",
    title: "极限营救",
    type: "movie",
    genres: ["动作", "冒险"],
    region: "美国",
    year: 2024,
    director: "Marcus Hale",
    cast: ["Ryan Ford", "Elena Cross", "David Ngo"],
    rating: 7.6,
    hot: 8890,
    duration: "134分钟",
    cover:
      "https://readdy.ai/api/search-image?query=Action%20adventure%20movie%20poster%20with%20a%20helicopter%20flying%20over%20a%20burning%20mountain%20road%2C%20explosive%20orange%20fire%20against%20cold%20steel%20blue%20sky%2C%20high%20octane%20blockbuster%20key%20art%2C%20dynamic%20composition&width=600&height=900&seq=ccvideo-m5&orientation=portrait",
    summary: "一支精锐小队深入山区，只为在风暴前完成一场不可能的营救。",
    synopsis: [
      "退役特工杰克接到旧友求助，前往偏远山区营救被困的科考队。",
      "随着时间逼近，任务逐渐暴露出幕后更大的阴谋，小队必须在极限中完成抉择。",
      "影片动作设计密集，场面调度利落，是标准的类型片爽感体验。",
    ],
    tags: ["动作", "营救", "冒险", "燃"],
  },
  {
    id: "m6",
    title: "雪岭归途",
    type: "movie",
    genres: ["剧情", "冒险"],
    region: "中国大陆",
    year: 2024,
    director: "李行舟",
    cast: ["高岩", "何清", "苏晚"],
    rating: 8.2,
    hot: 6020,
    duration: "122分钟",
    cover:
      "https://readdy.ai/api/search-image?query=Arthouse%20adventure%20drama%20movie%20poster%20of%20a%20lone%20traveler%20crossing%20a%20vast%20snow%20mountain%20ridge%20under%20pale%20moonlight%2C%20minimal%20cold%20blue%20and%20white%20palette%2C%20serene%20cinematic%20composition&width=600&height=900&seq=ccvideo-m6&orientation=portrait",
    summary: "一场暴雪封山，一位游子踏上漫长而孤独的归乡之路。",
    synopsis: [
      "在外漂泊多年的旅人得知家中变故，决定徒步穿越雪岭回到故乡。",
      "风雪、疲惫与回忆交织，路上遇到的陌生人让他重新理解了家的意义。",
      "影片以极简的叙事与壮阔的自然影像，呈现一段安静而有力量的旅程。",
    ],
    tags: ["雪岭", "归乡", "文艺", "自然"],
  },
  {
    id: "m7",
    title: "雨中曲调",
    type: "movie",
    genres: ["音乐", "爱情"],
    region: "法国",
    year: 2023,
    director: "Camille Rousseau",
    cast: ["Léa Martin", "Noah Bernard"],
    rating: 8.0,
    hot: 5340,
    duration: "108分钟",
    cover:
      "https://readdy.ai/api/search-image?query=Romantic%20musical%20movie%20poster%20with%20a%20pianist%20playing%20under%20glowing%20street%20lamps%20in%20the%20rain%2C%20reflective%20wet%20cobblestone%20streets%2C%20warm%20amber%20light%20with%20cool%20blue%20shadows%2C%20artistic%20cinematic%20art&width=600&height=900&seq=ccvideo-m7&orientation=portrait",
    summary: "一把旧钢琴，一场雨夜演出，让两个陌生人的命运交叠。",
    synopsis: [
      "街角咖啡馆的钢琴师遇见一位总在雨夜出现的女孩，两人因音乐结缘。",
      "随着旋律推进，各自的过往也缓缓揭开，他们学会用音符回应遗憾。",
      "影片音乐细腻，画面如画，是一封写给城市与音乐的情书。",
    ],
    tags: ["音乐", "浪漫", "艺术", "雨夜"],
  },
  {
    id: "t1",
    title: "都市之心",
    type: "tv",
    genres: ["都市", "剧情"],
    region: "中国大陆",
    year: 2025,
    director: "陈嘉树",
    cast: ["陈锋", "白鹭", "林夕", "顾一野"],
    rating: 8.6,
    hot: 9540,
    duration: "全40集",
    cover:
      "https://readdy.ai/api/search-image?query=Urban%20drama%20TV%20series%20poster%20with%20an%20elegant%20young%20professional%20woman%20standing%20before%20a%20city%20skyline%20at%20dusk%2C%20glass%20skyscrapers%2C%20cool%20blue%20tones%20with%20warm%20window%20lights%2C%20modern%20minimal%20key%20art&width=600&height=900&seq=ccvideo-t1&orientation=portrait",
    summary: "在快节奏的都市里，四个年轻人用各自的方式寻找归属。",
    synopsis: [
      "四个背景迥异的年轻人在同一栋写字楼相遇，事业、友情与情感在此交织。",
      "从初入职场的迷茫到独当一面，他们逐渐明白，真正的成长是学会与自己和解。",
      "剧集以细腻的群像刻画真实呈现都市生活的酸甜苦辣。",
    ],
    tags: ["都市", "群像", "成长", "职场"],
  },
  {
    id: "t2",
    title: "悬镜",
    type: "tv",
    genres: ["悬疑", "犯罪"],
    region: "中国大陆",
    year: 2024,
    director: "赵铭",
    cast: ["高岩", "许安琪", "沈墨"],
    rating: 9.0,
    hot: 9980,
    duration: "全24集",
    cover:
      "https://readdy.ai/api/search-image?query=Suspense%20crime%20TV%20series%20poster%20with%20a%20cracked%20mirror%20reflecting%20a%20shadowy%20figure%2C%20dark%20tone%2C%20single%20dramatic%20light%20beam%2C%20deep%20navy%20and%20crimson%20accents%2C%20eerie%20cinematic%20key%20art&width=600&height=900&seq=ccvideo-t2&orientation=portrait",
    summary: "刑侦专家组重启冷案，每一面「镜子」背后都藏着真相。",
    synopsis: [
      "省厅组建刑侦专家组重启多年未破的冷案，组长程野以独特的心理侧写手法逐步逼近真相。",
      "随着一个个案件被解开，一条贯穿全局的隐秘线索逐渐浮出水面。",
      "剧集逻辑缜密、节奏冷峻，是本年度口碑爆款悬疑剧。",
    ],
    tags: ["悬疑", "刑侦", "冷案", "高口碑"],
  },
  {
    id: "t3",
    title: "山海秘境",
    type: "tv",
    genres: ["奇幻", "古装"],
    region: "中国大陆",
    year: 2025,
    director: "王砚秋",
    cast: ["周牧云", "苏晚", "白鹭"],
    rating: 8.3,
    hot: 8760,
    duration: "全36集",
    cover:
      "https://readdy.ai/api/search-image?query=Chinese%20fantasy%20costume%20TV%20drama%20poster%20with%20a%20figure%20standing%20before%20misty%20mountains%20and%20floating%20islands%2C%20jade%20green%20and%20deep%20blue%20palette%2C%20ethereal%20glowing%20light%2C%20mythological%20epic%20key%20art&width=600&height=900&seq=ccvideo-t3&orientation=portrait",
    summary: "山海之间，一场横跨三界的奇遇与宿命缓缓展开。",
    synopsis: [
      "少年医师江寒意外得到一卷古老地图，为寻找失踪的师门踏遍山海秘境。",
      "在守护与抉择中，他逐渐认清自己肩负的宿命，也与同伴结下深厚情谊。",
      "剧集世界观扎实，特效与美术在线，呈现东方奇幻之美。",
    ],
    tags: ["奇幻", "古装", "东方美学", "冒险"],
  },
  {
    id: "t4",
    title: "家族荣耀",
    type: "tv",
    genres: ["家庭", "年代"],
    region: "中国大陆",
    year: 2023,
    director: "李行舟",
    cast: ["周牧云", "何清", "高岩", "林夕"],
    rating: 8.5,
    hot: 7420,
    duration: "全45集",
    cover:
      "https://readdy.ai/api/search-image?query=Chinese%20period%20family%20TV%20drama%20poster%20showing%20a%20grand%20traditional%20courtyard%20mansion%20at%20sunset%2C%20warm%20amber%20lanterns%20glowing%2C%20nostalgic%20sepia%20and%20teal%20tones%2C%20elegant%20cinematic%20key%20art&width=600&height=900&seq=ccvideo-t4&orientation=portrait",
    summary: "三代人的家国故事，在小院与大时代之间缓缓流淌。",
    synopsis: [
      "故事从一间老宅院展开，讲述一个家族在时代变迁中的起落与坚守。",
      "祖辈的勤勉、父辈的抉择与年轻一代的突围，交织成一段厚重的家族史。",
      "剧集人物饱满、情感真挚，唤起几代观众的共鸣。",
    ],
    tags: ["家族", "年代", "温情", "传承"],
  },
  {
    id: "t5",
    title: "刑侦档案·追光",
    type: "tv",
    genres: ["犯罪", "剧情"],
    region: "中国大陆",
    year: 2025,
    director: "陈嘉树",
    cast: ["陈锋", "沈墨", "许安琪"],
    rating: 8.1,
    hot: 6890,
    duration: "全30集",
    cover:
      "https://readdy.ai/api/search-image?query=Police%20procedural%20crime%20TV%20poster%20with%20a%20detective%20badge%20and%20evidence%20photos%20on%20a%20dim%20desk%2C%20single%20warm%20desk%20lamp%2C%20deep%20blue%20and%20amber%20tones%2C%20gritty%20documentary%20style%20key%20art&width=600&height=900&seq=ccvideo-t5&orientation=portrait",
    summary: "一线刑警的真实日常，在证据与人心之间追索真相。",
    synopsis: [
      "以纪实手法呈现刑警队的日常工作，每集聚焦一起案件。",
      "从现场勘查到审讯博弈，剧集还原了大量真实细节。",
      "在冷峻的案件背后，是对人性与责任的持续追问。",
    ],
    tags: ["刑侦", "纪实", "犯罪", "单元剧"],
  },
  {
    id: "t6",
    title: "孤岛谜案",
    type: "tv",
    genres: ["悬疑", "剧情"],
    region: "英国",
    year: 2024,
    director: "Oliver Grant",
    cast: ["Emma Blythe", "James Hart", "Nora Fen"],
    rating: 8.4,
    hot: 6130,
    duration: "全8集",
    cover:
      "https://readdy.ai/api/search-image?query=British%20mystery%20mini-series%20poster%20with%20a%20stormy%20isolated%20island%20and%20a%20lighthouse%20in%20fog%2C%20muted%20grey%20blue%20tone%2C%20a%20single%20warm%20lighthouse%20beam%2C%20moody%20atmospheric%20key%20art&width=600&height=900&seq=ccvideo-t6&orientation=portrait",
    summary: "一座与世隔绝的小岛，七名来客，一场无法解释的失踪。",
    synopsis: [
      "一群互不相识的人受邀来到一座私人岛屿，却发现主人始终未曾现身。",
      "随着风暴封锁退路，成员接连失踪，每个人似乎都隐瞒着秘密。",
      "剧集短小精悍，悬念层层递进，结尾出人意料。",
    ],
    tags: ["悬疑", "孤岛", "英剧", "密室"],
  },
  {
    id: "v1",
    title: "明星大竞技",
    type: "variety",
    genres: ["真人秀", "竞技"],
    region: "中国大陆",
    year: 2025,
    director: "综艺制作中心",
    cast: ["群星阵容"],
    rating: 8.0,
    hot: 9120,
    duration: "每周五更新",
    cover:
      "https://readdy.ai/api/search-image?query=Vibrant%20variety%20show%20poster%20with%20colorful%20stage%20lights%20and%20confetti%2C%20energetic%20game%20show%20atmosphere%2C%20bright%20orange%20and%20teal%20palette%2C%20playful%20dynamic%20key%20art&width=600&height=900&seq=ccvideo-v1&orientation=portrait",
    summary: "全明星阵容同台竞技，笑点与反转不断的高能综艺。",
    synopsis: [
      "多组明星嘉宾在精心设计的关卡中展开趣味竞技，既有体力考验也有脑力博弈。",
      "节目赛制新颖、互动性强，每期都能带来意想不到的笑料与感动。",
      "轻松解压的合家欢综艺，适合全家一起观看。",
    ],
    tags: ["综艺", "竞技", "喜剧", "明星"],
  },
  {
    id: "v2",
    title: "美食环游记",
    type: "variety",
    genres: ["美食", "旅行"],
    region: "中国大陆",
    year: 2024,
    director: "综艺制作中心",
    cast: ["美食探店团"],
    rating: 8.5,
    hot: 8350,
    duration: "全12期",
    cover:
      "https://readdy.ai/api/search-image?query=Food%20travel%20variety%20show%20poster%20with%20steaming%20regional%20dishes%20on%20a%20rustic%20wooden%20table%2C%20warm%20cozy%20lighting%2C%20rich%20orange%20and%20green%20palette%2C%20appetizing%20documentary%20style%20key%20art&width=600&height=900&seq=ccvideo-v2&orientation=portrait",
    summary: "走遍大江南北，用一档节目记录最真实的人间烟火。",
    synopsis: [
      "主持团队走进不同城市，探访当地小馆与家常味道，记录食物背后的故事。",
      "节目既有诱人的美食画面，也有温暖的市井人情。",
      "一部让人食指大动又心生暖意的治愈系综艺。",
    ],
    tags: ["美食", "旅行", "治愈", "纪录片"],
  },
  {
    id: "v3",
    title: "音乐无界",
    type: "variety",
    genres: ["音乐", "竞演"],
    region: "中国大陆",
    year: 2025,
    director: "音乐频道",
    cast: ["实力唱将"],
    rating: 8.7,
    hot: 8790,
    duration: "每周六更新",
    cover:
      "https://readdy.ai/api/search-image?query=Music%20competition%20variety%20show%20poster%20with%20a%20singer%20silhouette%20under%20a%20spotlight%20on%20stage%2C%20glowing%20particle%20light%2C%20violet%20blue%20and%20gold%20stage%20lighting%2C%20dramatic%20concert%20key%20art&width=600&height=900&seq=ccvideo-v3&orientation=portrait",
    summary: "跨越风格边界的音乐竞演，让每一种声音都被听见。",
    synopsis: [
      "来自不同音乐领域的歌手同台竞演，用改编与原创碰撞出全新火花。",
      "节目注重音乐本身，既有经典改编，也有新人作品的惊艳亮相。",
      "对于热爱音乐的人来说，这是一场持续整季的听觉盛宴。",
    ],
    tags: ["音乐", "竞演", "舞台", "现场"],
  },
  {
    id: "v4",
    title: "奇妙探案团",
    type: "variety",
    genres: ["推理", "真人秀"],
    region: "中国大陆",
    year: 2024,
    director: "综艺制作中心",
    cast: ["推理嘉宾团"],
    rating: 7.8,
    hot: 7020,
    duration: "全10期",
    cover:
      "https://readdy.ai/api/search-image?query=Murder%20mystery%20variety%20show%20poster%20with%20clue%20boards%20and%20magnifying%20glass%20on%20a%20dim%20table%2C%20stylized%20comic%20detective%20theme%2C%20deep%20indigo%20and%20amber%20palette%2C%20playful%20suspense%20key%20art&width=600&height=900&seq=ccvideo-v4&orientation=portrait",
    summary: "嘉宾化身侦探，在实景剧情中展开一场沉浸式推理。",
    synopsis: [
      "每期节目构建一个完整的故事场景，嘉宾们通过线索推理还原真相。",
      "节目兼具趣味与烧脑，观众也可以跟着一起解谜。",
      "适合喜欢推理游戏的观众，互动代入感十足。",
    ],
    tags: ["综艺", "推理", "沉浸", "烧脑"],
  },
];